export default "__VITE_ASSET__CK9wz6er__"